const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(410px, 1fr))',
    width: '100%',
    height: '150px',
    gap: theme.spacing(3),
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    },
    // add animation here for gridTemplateColumns
    transition: 'grid-template-columns 0.3s ease-in-out',
  },
})
export default styles
